import React, { useState } from "react";
import dayjs from "dayjs";
import Box from "@mui/material/Box";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

export default function DateCalendar({ title }) {
  const [selectedDate, setSelectedDate] = useState(dayjs(new Date()));
  const [isDatePickerOpen, setDatePickerOpen] = useState(false);

  const handleDateClick = () => {
    setDatePickerOpen(!isDatePickerOpen);
  };

  const handleDateChange = (newDate) => {
    setSelectedDate(newDate);
    setDatePickerOpen(false);
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Box
        sx={{
          // marginTop: '1px',
          // marginBottom: '1px',
          // marginLeft: '1px',
          boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.3)",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          textAlign: "center",
          borderRadius: "20px",
          height: "210px",
          width: "300px",
          background: "linear-gradient(to bottom, lightgreen 10%, white 90%)",
        }}
      >
        <div onClick={handleDateClick} style={{ cursor: "pointer" }}>
          <div style={{ fontSize: "25px" }}>{selectedDate.format("MMM")}</div>
          <div style={{ display: "inline" }}>{selectedDate.format(" ")}</div>
          <div style={{ fontSize: "52px" }}>{selectedDate.format("D")}</div>
        </div>
        {isDatePickerOpen && (
          <DatePicker
            value={selectedDate}
            onChange={handleDateChange}
            format="DD MMM HH:mm"
            open={isDatePickerOpen}
            onClose={() => setDatePickerOpen(false)}
          />
        )}
      </Box>
    </LocalizationProvider>
  );
}
